import { render, staticRenderFns } from "./LookupSetting.vue?vue&type=template&id=460a4ac6&scoped=true&"
import script from "./LookupSetting.vue?vue&type=script&lang=ts&"
export * from "./LookupSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LookupSetting.vue?vue&type=style&index=0&id=460a4ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a4ac6",
  null
  
)

export default component.exports